var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-blurb",class:{ vertical: _vm.isVertical }},[_c('h3',{staticClass:"metadata-blurb__title"},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"metadata-blurb__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }